<template>
  <template v-if="column.recruiterManagesWorkers">
    <WdsLabel v-if="column.recruiterOwnershipIsExpired" error subtle>{{ $t('Expired') }}</WdsLabel>
  </template>
  <template v-else>-</template>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/composables/translation'

const HireHasStaffingAgencyColumn = graphql(`
  fragment HireHasStaffingAgencyColumn on Hire {
    recruiterFee
    recruiterOwnershipStartDate
    recruiterOwnershipDays
    recruiterOwnershipIsExpired
    recruiterOwnershipDaysLeft
    recruiterManagesWorkers
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireHasStaffingAgencyColumn> }>()
const column = computed(() => useFragment(HireHasStaffingAgencyColumn, props.row))
</script>

<style lang="scss">
.hire-column-worker-information {
  text-align: left;
}
</style>
